import { ArrowDown, ArrowUp } from '@phosphor-icons/react';
import React from 'react';

const Column = (props) => {
  const {
    column,
    appliedSorts,
  } = props;

  return (
    <div className={`column-header text-grey-70 label-14 ${column?.field}`}>
      {column?.columnElement ? column.columnElement : column?.label}
      {(appliedSorts?.sort === column?.field) && (
        appliedSorts?.type === 'desc' ?
          (<ArrowDown
            color="#FF2459"
            size={16}
          />)
          : (
            <ArrowUp
              color="#FF2459"
              size={16}
            />)
      )}
    </div>
  );
};

export default Column;